import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

// AUTH
export const authComputed = {
  ...mapState('auth', [
    'currentUser',
    'totalUnread',
    'latestMessages',
    'chatData',
  ]),
  ...mapGetters('auth', [
    'loggedIn',
    'isSubscribed',
    'roles',
    'userName',
    'userOrgId',
    'trainerId',
    'fitnessToken',
    'streamAppId',
    'streamChatClient',
    'trainerEmail',
    'trainerFullName',
    'trainerFirstName',
    'userOrgName',
    'isTrainerEnrolledInACohort',
    'campaigns',
  ]),
};
export const authMethods = {
  ...mapActions('auth', [
    'logIn',
    'logOut',
    'register',
    'checkout',
    'checkCoupon',
    'getOrg',
    'changePassword',
    'resetPassword',
    'confirmPasswordReset',
    'getChatData',
    'addPrice',
    'removePrice',
    'addCoupon',
    'removeCoupon',
    'validate',
  ]),
  ...mapMutations('auth', [
    'SET_CURRENT_USER_FITNESS_TOKEN',
    'SET_UPDATE_CHAT_DATA',
    'SET_CHAT_DATA',
    'SET_UNREAD_COUNT',
    'SET_AUTH_CHECKED',
  ]),
};

// ADMIN PANEL
export const adminPanelComputed = {
  ...mapState('adminPanel', [
    'isAdminPanelActive',
    'panelContent',
    'adminPanelError',
  ]),
};
export const adminPanelMethods = {
  ...mapMutations('adminPanel', [
    'setPanelContent',
    'setShowAdminPanel',
    'setHideAdminPanel',
    'setHidePanelContentDetail',
    'setAdminPanelError',
  ]),
};

// ALERT
export const alertComputed = {
  ...mapState('alert', ['showAlert', 'showAlertBanner', 'alertText']),
};
export const alertMethods = {
  ...mapMutations('alert', [
    'setShowAlert',
    'setShowAlertBanner',
    'setAlertText',
  ]),
};

// CAMPAIGN
export const campaignComputed = {
  ...mapState('campaign', [
    'selectedCampaign',
    'campaignRecipients',
    'overriddenCampaignEmailTemplate',
    'overriddenCampaignSmsTemplate',
    'recipientCount',
  ]),
  ...mapGetters('campaign', []),
};
export const campaignMethods = {
  ...mapMutations('campaign', [
    'setSelectedCampaign',
    'setAddCampaignRecipient',
    'setRemoveCampaignRecipient',
    'setRecipientSelectedCommsOpt',
    'setUpdateRecipientMsg',
    'setUpdateRecipientCount',
    'setRecipientCount',
    'setClearCampaignRecipients',
  ]),
};

// CIRCUIT
export const circuitComputed = {
  ...mapGetters('circuit', ['hasUnsavedCircuitChanges']),
  ...mapState('circuit', [
    'allCircuits',
    'circuitDetails',
    'circuitModel',
    'selectedCircuit',
    'newCircuit',
    'isFiltering',
    'initAllCircuits',
    'hasUnsavedCircuitChanges',
    'goToCircuit',
  ]),
};
export const circuitMethods = {
  ...mapActions('circuit', [
    'getAllCircuits',
    'getCircuit',
    'getCircuitShape',
    'createCircuit',
    'updateCircuit',
    'deleteCircuit',
  ]),
  ...mapMutations('circuit', [
    'setAllCircuits',
    'setDeleteCircuitItem',
    'setSelectedCircuit',
    'setAddCircuitExercise',
    'setRemoveCircuitExercise',
    'setMoveCircuitExerciseUp',
    'setMoveCircuitExerciseDown',
    'setUpdateExerciseSet',
    'setUpdateExerciseSetReps',
    'setUpdateExerciseSetTime',
    'setUpdateExerciseSetWeight',
    'setUpdateExerciseSetRest',
    'toggleNewCircuitPlaceholder',
    'toggleIsFiltering',
    'setInitAllCircuits',
    'setHasUnsavedCircuitChanges',
    'setGoToCircuit',
  ]),
};

// CLIENT PROGRAM
export const clientProgramComputed = {
  ...mapState('clientProgram', [
    'AllClientProgram',
    'selectedWeek',
    'selectedDay',
    'selectedAllWeek',
    'duplicateToWeekNumber',
    'programDay',
    'programOverridden',
    'dragModalCtx',
  ]),
};
export const clientProgramMethods = {
  ...mapActions('clientProgram', [
    'getAllClientProgram',
    'addUpdateWorkoutDay',
    'deleteWorkoutDay',
    'addUpdateTrainerNote',
    'deleteTrainerNote',
    'getAllDay',
    'addUpdateCheckin',
    'deleteCheckinDay',
    'duplicateToADay',
    'duplicateToAWeek',
    'clearAllDayEvents',
    'clearAllWeekEvents',
    'clearAllClientProgram',
    'updateProgramDay',
    'getProgramWeeks',
    'getProgramRange',
    'overrideClientProgram',
  ]),
  ...mapMutations('clientProgram', [
    'setAllClientProgram',
    'setSelectedWeek',
    'setSelectedDay',
    'setSelectedAllWeek',
    'setDuplicateToWeekNumber',
    'setProgramDay',
    'setUpdateProgramWorkout',
    'setUpdateProgramWorkoutExerciseSet',
    'setUpdateProgramWorkoutExerciseSetReps',
    'setUpdateProgramWorkoutExerciseSetTime',
    'setUpdateProgramWorkoutExerciseSetWeight',
    'setUpdateProgramWorkoutExerciseSetRest',
    'setUpdateProgramWorkoutCircuitIntro',
    'setUpdateProgramWorkoutCircuitOutro',
    'setProgramOverridden',
    'setMoveProgramNote',
    'setMoveProgramCheckin',
    'setMoveProgramWorkout',
    'setUpdateWeekItem',
    'setDragModalCtx',
  ]),
};

// PROGRAM
export const programComputed = {
  ...mapGetters('program', ['hasUnsavedProgramChanges']),
  ...mapState('program', [
    'programModel',
    'selectedProgram',
    'allPrograms',
    'allProgramsTrueSource',
    'hasUnsavedProgramChanges',
  ]),
};
export const programMethods = {
  ...mapActions('program', [
    'getProgramModel',
    'createNewProgram',
    'duplicateProgram',
    'getAllPrograms',
    'updateProgram',
    'getProgram',
    'deleteProgram',
  ]),
  ...mapMutations('program', [
    'setProgramModel',
    'setSelectedProgram',
    'setAllPrograms',
    'setUpdateProgramItem',
    'setDeleteProgramItem',
    'setHasUnsavedProgramChanges',
  ]),
};

// PROSPECT
export const prospectComputed = {
  ...mapState('prospect', [
    'allProspects',
    'contacts',
    'selectedProspect',
    'overriddenCampaignTemplate',
    'overriddenMsgTemplate',
    'convertedClient',
    'discardProspectChanges',
    'hasUnsavedProspectChanges',
    'prospectConfirmationContext',
    'isRequestingProspect',
  ]),
  ...mapGetters('prospect', [
    'emptyContacts',
    'selectedProspectFullName',
    'prospectsRepliedCount',
  ]),
};
export const prospectMethods = {
  ...mapMutations('prospect', [
    'setAllProspects',
    'setSelectedProspect',
    'setSelectedProspectFirstName',
    'setSelectedProspectLastName',
    'setSelectedProspectPreferredConnOpt',
    'setTogglePreferredConnOpt',
    'setProspectSelectedCommsOpt',
    'setUpdateSelectedProspectPhoneConnOpt',
    'setUpdateSelectedProspectEmailConnOpt',
    'setUpdateSelectedProspectConnOpts',
    'setOverriddenCampaignTemplate',
    'setOverriddenMultiCampaignTemplate',
    'setResetOverriddenMultiCampaignTemplate',
    'setContacts',
    'updateContact',
    'setSelectedContacts',
    'selectAllContacts',
    'setInitialImport',
    'setConvertedClient',
    'setResetProspectUnreadCount',
    'splitProspectConnOpts',
    'setHasUnsavedProspectChanges',
    'setDiscardProspectChanges',
    'setProspectConfirmationContext',
    'setIsRequestingProspect',
    'setCancelGetProspectRequest',
  ]),
  ...mapActions('prospect', [
    'getAllProspects',
    'getProspect',
    'updateProspect',
    'contactProspects',
    'verifyProspects',
    'convertProspect',
    'deleteProspect',
  ]),
};

// TRAINER
export const trainerComputed = {
  ...mapState('trainer', [
    'allTrainers',
    'clientActivity',
    'selectedTrainer',
    'trainerModel',
    'selectedProduct',
    'hasUnsavedFeedbackChanges',
  ]),
  ...mapGetters('trainer', ['hasUnsavedFeedbackChanges']),
};
export const trainerMethods = {
  ...mapActions('trainer', [
    'getAllTrainers',
    'getClientActivity',
    'createTrainer',
    'updateTrainer',
    'updateTrainerNotes',
    'getTrainerShape',
    'createTrainerProductPrice',
    'deleteTrainerProductPrice',
    'createTrainerCoupon',
    'deleteTrainerCoupon',
    'cancelTrainerSubscription',
    'addTrainerCard',
    'updateTrainerClientFeedback',
  ]),
  ...mapMutations('trainer', [
    'setAllTrainers',
    'setClientActivity',
    'setSelectedTrainer',
    'setUpdateTrainerProp',
    'setSelectedProduct',
    'setUpdateClientCheckInFeedback',
    'setHasUnsavedFeedbackChanges',
  ]),
};

// CLIENT
export const clientComputed = {
  ...mapState('client', [
    'selectedClient',
    'allClient',
    'allClientClone',
    'selectedImage',
    'visitedClient',
    'selectedProductItem',
    'clientConfirmationContext',
    'clientUpdates',
  ]),
  ...mapGetters('client', [
    'joinedClientsProducts',
    'totalEarning',
    'totalClients',
    'allClientsCount',
  ]),
};
export const clientMethods = {
  ...mapActions('client', [
    'getAllClient',
    'createClient',
    'updateClient',
    'inviteClient',
    'getClient',
    'hasUnreadMessages',
    'archiveClient',
  ]),
  ...mapMutations('client', [
    'setSelectedClient',
    'setCreateClient',
    'setUpdateClientItem',
    'setAllClient',
    'setAllClientClone',
    'setSelectedImage',
    'setVisitedClient',
    'setHasUnreadMessages',
    'setSelectedProductItem',
    'setArchiveClient',
    'setClientConfirmationContext',
  ]),
};

// EQUIPMENT
export const equipmentComputed = {
  ...mapState('equipment', [
    'allEquipment',
    'allEquipmentTrueSource',
    'equipmentDetails',
    'equipmentModel',
    'selectedEquipment',
  ]),
  ...mapGetters('equipment', [
    'equipmentLabelMap',
    'equipmentIdMap',
    'equipmentTrainerMap',
  ]),
};
export const equipmentMethods = {
  ...mapActions('equipment', [
    'getAllEquipment',
    'getEquipment',
    'getEquipmentShape',
    'createEquipment',
    'updateEquipment',
    'deleteEquipment',
  ]),
  ...mapMutations('equipment', [
    'setAllEquipment',
    'setUpdateEquipmentItem',
    'setDeleteEquipmentItem',
    'setSelectedEquipment',
  ]),
};

// EQUIPMENT TYPES
export const equipmentTypeComputed = {
  ...mapState('equipmentType', ['equipmentTypes']),
  ...mapGetters('equipmentType', [
    'equipmentTypeNameMap',
    'equipmentTypeIdMap',
  ]),
};
export const equipmentTypeMethods = {
  ...mapActions('equipmentType', ['getEquipmentTypes']),
};

// EXERCISE
export const exerciseComputed = {
  ...mapState('exercise', [
    'allExercises',
    'allExercisesTrueSource',
    'exerciseDetails',
    'exerciseModel',
    'selectedExercise',
    'selectedAltExercise',
    'selectedStep',
    'exerciseStep',
    'hasUnsavedExerciseChanges',
    'exerciseFilter',
  ]),
  ...mapGetters('exercise', [
    'exerciseMap',
    'exerciseLabelMap',
    'exerciseIdMap',
    'exerciseTrainerMap',
    'hasUnsavedExerciseChanges',
  ]),
};
export const exerciseMethods = {
  ...mapActions('exercise', [
    'getAllExercises',
    'getExercise',
    'getExerciseShape',
    'createExercise',
    'updateExercise',
    'deleteExercise',
  ]),
  ...mapMutations('exercise', [
    'setAllExercises',
    'setUpdateExercise',
    'setDeleteExerciseItem',
    'setSelectedExercise',
    'setUpdateExerciseTitle',
    'setSelectedAltExercise',
    'setSelectedStep',
    'setRemoveWeightedEquip',
    'setRemoveUnweightedEquip',
    'setAddStep',
    'setUpdateStep',
    'setRemoveStep',
    'setMoveStepUp',
    'setMoveStepDown',
    'setRemoveExerciseMuscleGroup',
    'setHasUnsavedExerciseChanges',
    'setExercisesFilter',
  ]),
};

// EXERCISE DIFFICULTY
export const exerciseDifficultyComputed = {
  ...mapState('exerciseDifficulty', [
    'allExerciseDifficulties',
    'exerciseDifficultyDetails',
  ]),
  ...mapGetters('exerciseDifficulty', [
    'exerciseDifficultyLabelMap',
    'exerciseDifficultyIdMap',
  ]),
};
export const exerciseDifficultyMethods = {
  ...mapActions('exerciseDifficulty', [
    'getAllExerciseDifficulties',
    'getExerciseDifficulty',
    'createExerciseDifficulty',
    'updateExerciseDifficulty',
    'deleteExerciseDifficulty',
  ]),
  ...mapMutations('exerciseDifficulty', ['setDeleteExerciseDifficultyItem']),
};

// GROCERY
export const groceryComputed = {
  ...mapState('grocery', ['groceryList', 'selectedItem', 'isListActive']),
};
export const groceryMethods = {
  ...mapMutations('grocery', [
    'setDeleteGroceryItem',
    'setSelectedItem',
    'setNewGroceryItem',
    'setUpdateGroceryItem',
    'setToggleList',
  ]),
};

// LEARN
export const learnComputed = {
  ...mapGetters('learn', ['myCohorts', 'fyf5Cohort']),
  ...mapState('learn', ['selectedCohort']),
};
export const learnMethods = {
  ...mapMutations('learn', ['SET_MY_COHORTS', 'setSelectedCohort']),
  ...mapActions('learn', ['enrollTrainer', 'getCohorts', 'trackModuleWatch']),
};

// MEDIA UPLOAD
export const mediaComputed = {
  ...mapState('mediaUpload', [
    'uploadedCoverImageUrl',
    'uploadedThumbnailImageUrl',
    'uploadedCoverVideoUrl',
    'uploadedThumbnailVideoUrl',
    'isNewMediaAsset',
    'tempPhotoPreview',
    'signedPostData',
    'recipeImageBlob',
  ]),
  ...mapGetters('mediaUpload', ['hasNewMedia']),
};
export const mediaMethods = {
  ...mapActions('mediaUpload', [
    'getS3UploadUrl',
    'uploadPhoto',
    'getCloudinaryUploadUrl',
    'uploadToCloudinary',
    'clearMedia',
    'cancelUpload',
  ]),
  ...mapMutations('mediaUpload', [
    'setSignedPostData',
    'setSignedPostDataUrlByIndex',
    'setSignedPostDataSuccessByIndex',
    'setSignedPostDataCancelFuncByIndex',
    'setIsNewMediaAsset',
    'setTempPhotoPreview',
    'setClearUploadedMediaStates',
    'setRecipeImageBlob',
  ]),
};

// MODALS
export const modalComputed = {
  ...mapState('modal', [
    'selectedItem',
    'selectedImage',
    'notifyModalContext',
    'continueRoute',
  ]),
};
export const modalMethods = {
  ...mapMutations('modal', [
    'setSelectedItem',
    'setSelectedImage',
    'setNotifyModalContext',
    'setContinueRoute',
  ]),
};

// MUSCLE GROUP
export const muscleGroupComputed = {
  ...mapState('muscleGroup', ['allMuscleGroups', 'muscleGroupDetails']),
  ...mapGetters('muscleGroup', ['muscleGroupLabelMap', 'muscleGroupIdMap']),
};
export const muscleGroupMethods = {
  ...mapActions('muscleGroup', [
    'getAllMuscleGroups',
    'getMuscleGroup',
    'createMuscleGroup',
    'updateMuscleGroup',
    'deleteMuscleGroup',
  ]),
  ...mapMutations('muscleGroup', ['setDeleteMuscleGroupItem']),
};

// NUTRITION
export const nutritionComputed = {
  ...mapState('nutrition', [
    'autoCompleteLists',
    'nutritionDiets',
    'nutritionHealths',
    'nutritionTags',
  ]),
};
export const nutritionMethods = {
  ...mapActions('nutrition', [
    'getNutritionDiets',
    'getNutritionHealths',
    'getNutritionTags',
    'getAutocompleteLists',
  ]),
};

// PLATELIST
export const platelistComputed = {
  ...mapState('platelist', [
    'allPlatelists',
    'initAllPlatelists',
    'adminPlanWeek',
    'isAddingDish',
    'isSavingDish',
    'selectedPlatelist',
    'selectedMealtime',
    'selectedPlanDay',
    'selectedWeekOffset',
    'selectedMealtimeDish',
    'clearMealPlanFilters',
    'showPlatelistArchivedOverlay',
    'hasUnsavedPlatelistChanges',
    'discardPlatelistChanges',
    'platelistFilter',
  ]),
};
export const platelistMethods = {
  ...mapMutations('platelist', [
    'setAllPlatelists',
    'setSelectedPlatelist',
    'setSelectedMealtime',
    'setSelectedPlanDay',
    'setNewPlatelistPlaceholder',
    'setRemovePlatelistPlaceholder',
    'setSelectedWeekOffset',
    'setIsAddingDish',
    'setIsSavingDish',
    'setSelectedMealtimeDish',
    'setClearMealPlanFilters',
    'setAdminPlanWeek',
    'setFilterTrainerOnlyPlatelists',
    'setShowPlatelistArchivedOverlay',
    'setHasUnsavedPlatelistChanges',
    'setDiscardPlatelistChanges',
    'setPlateListFilter',
  ]),
  ...mapActions('platelist', [
    'getAllPlatelists',
    'getPlatelist',
    'getAdminPlanGrid',
    'createPlatelist',
    'updatePlatelist',
    'addMealToPlatelist',
    'removeMealFromPlatelist',
    'updateLeftoverDish',
  ]),
};

// RECIPE
export const recipeComputed = {
  ...mapState('recipe', [
    'allRecipes',
    'recipeDetails',
    'selectedRecipe',
    'selectedRecipeStep',
    'recipeFilterOpts',
    'selectedRecipeFilterOpts',
    'isLoadingRecipes',
    'clearRecipeFilters',
    'hasUnsavedRecipeChanges',
    'updatedNutritionValues',
    'discardRecipeChanges',
    'showRecipeArchivedOverlay',
    'recipesFilter',
  ]),
};
export const recipeMethods = {
  ...mapMutations('recipe', [
    'setAllRecipes',
    'setSelectedRecipe',
    'setSelectedRecipeFilterOpts',
    'setFilterTrainerOnlyRecipes',
    'setFilterOrgOnlyRecipes',
    'setSelectedRecipeStep',
    'setIsLoadingRecipes',
    'setAddInstructionStep',
    'setAddIngredientStep',
    'setUpdateRecipeTitle',
    'setUpdateRecipeDescription',
    'setCreateRecipeNutritionUnits',
    'setUpdateRecipeNutritionUnits',
    'setClearRecipeNutritionUnits',
    'setUpdatedNutritionValues',
    'setUpdateIngredientStep',
    'setUpdateInstructionStep',
    'setRemoveInstructionStep',
    'setRemoveIngredientStep',
    'setMoveInstructionStep',
    'setMoveIngredientStep',
    'setMoveInstructionStepDown',
    'setClearRecipeFilters',
    'setUpdateRecipeType',
    'setUpdateRecipeMealtimes',
    'setUpdateRecipeStatus',
    'setUpdateRecipeCookHours',
    'setUpdateRecipeCookMinutes',
    'setRecipeNutritionDigest',
    'setRecipeDetailsNutritionDigest',
    'setUpdateRecipeCalories',
    'setUpdateRecipeServings',
    'setUpdateRecipeServingsText',
    'setHasUnsavedRecipeChanges',
    'setToggleRecipeFlaggedStatus',
    'setDiscardRecipeChanges',
    'setShowRecipeArchivedOverlay',
    'setRecipesFilter',
  ]),
  ...mapActions('recipe', [
    'getAllRecipes',
    'getRecipe',
    'getRecipeFilterOpts',
    'createRecipe',
    'updateRecipe',
    'updateRecipeNutritionUnits',
  ]),
};

// SIDEBAR
export const sidebarComputed = {
  ...mapState('sidebar', ['isSidebarCollapsed']),
};
export const sidebarMethods = {
  ...mapMutations('sidebar', ['setIsSidebarCollapsed']),
};

// FitnessType
export const fitnessTypeComputed = {
  ...mapState('fitnessType', [
    'allFitnessTypes',
    'selectedFitnessType',
    'allFitnessTypesTrueSource'
  ]),
  ...mapGetters('fitnessType', ['hasUnsavedChanges']),
};
export const fitnessTypeMethods = {
  ...mapActions('fitnessType', [
    'getAllFitnessTypes',
    'getFitnessType',
    'getFitnessTypeShape',
    'createFitnessType',
    'updateFitnessType',
    'deleteFitnessType',
    'setHasChanges',
  ]),
  ...mapMutations('fitnessType', [
    'setAllFitnessTypes',
    'setSelectedFitnessType',
    'setUpdateFitnessTypeTitle',
    'setUpdateFitnessTypeDescription',
    'setHasChanges',
    'setAllFitnessTypesTrueSource',
    'setFitnessTypeDetails',
    'setFitnessTypeModel',
    'setCreateFitnessType',
    'setUpdateFitnessTypeItem',
    'setDeleteFitnessTypeItem',
  ]),
};

// WORKOUT
export const workoutComputed = {
  ...mapState('workout', [
    'allWorkouts',
    'allWorkoutsTrueSource',
    'workoutModel',
    'selectedWorkout',
    'timeFilterOpts',
    'isLibraryWorkout',
    'initialLibraryWorkout',
    'duplicateCircuitError',
    'hasUnsavedChanges',
    'workoutFilter',
  ]),
  ...mapGetters('workout', ['hasInvalidWorkout', 'hasUnsavedChanges']),
};
export const workoutMethods = {
  ...mapActions('workout', [
    'getAllWorkouts',
    'getWorkout',
    'getWorkoutShape',
    'createWorkout',
    'updateWorkout',
    'deleteWorkout',
    'setHasChanges',
  ]),
  ...mapMutations('workout', [
    'setAllWorkouts',
    'setSelectedWorkout',
    'setAddWorkoutCircuit',
    'setUpdateWorkoutTitle',
    'setUpdateWorkoutDescription',
    'setUpdateWorkoutMuscleGroup',
    'setRemoveWorkoutMuscleGroup',
    'setUpdateWorkoutDifficulty',
    'setUpdateWorkoutDuration',
    'setUpdateWorkoutExerciseSetReps',
    'setUpdateWorkoutExerciseSetTime',
    'setUpdateWorkoutExerciseSetWeight',
    'setUpdateWorkoutExerciseSetRest',
    'setUpdateWorkoutExerciseSet',
    'setUpdateWorkoutCircuitReps',
    'setRemoveWorkoutCircuit',
    'setRemoveWorkoutCircuitExercise',
    'setMoveWorkoutCircuitUp',
    'setMoveWorkoutCircuitDown',
    'setAddWorkoutCircuitLabel',
    'setAddWorkoutCircuitDetails',
    'setAddWorkoutCircuitExercise',
    'setIsLibraryWorkout',
    'setInitialLibraryWorkout',
    'setDuplicateCircuitError',
    'setHasChanges',
    'setAddUniqueId',
    'setMoveWorkoutExerciseDown',
    'setMoveWorkoutExerciseUp',
    'setDeleteWorkoutItem',
    'setWorkoutFilter',
  ]),
};

// ORGANIZATION
export const organizationComputed = {
  ...mapGetters('organization', [
    'organizationTitle',
    'organizationSupportEmail',
    'organizationLogo',
    'organizationPricingURL',
    'organizationColor',
  ]),
};

export const organizationMethods = {
  ...mapActions('organization', ['getOrg']),
};
